import React, { useEffect } from 'react';
import Header from '../Header/Header';
import './MenuBrowseSkeleton.css';

const Shimmer: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`mb-skel-shimmer ${className}`.trim()} aria-hidden="true" />
);

const MenuBrowseSkeleton: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('menu-browse-active');
    return () => document.body.classList.remove('menu-browse-active');
  }, []);

  return (
    <div className="menu-browse-page menu-browse-page--skeleton" aria-busy="true" aria-label="Loading menu">
      <Header />

      <header className="menu-browse-header mb-skel-header">
        <Shimmer className="mb-skel-header-btn" />
        <Shimmer className="mb-skel-header-title" />
        <div className="menu-browse-header-actions">
          <Shimmer className="mb-skel-view-switch" />
          <Shimmer className="mb-skel-header-btn" />
          <Shimmer className="mb-skel-cart-btn" />
        </div>
      </header>

      <div className="menu-browse-shell">
        <div className="menu-browse-body">
          <aside className="menu-browse-rail-wrap mb-skel-rail" aria-hidden>
            {Array.from({ length: 7 }).map((_, i) => (
              <div key={i} className="mb-skel-rail-item">
                <Shimmer className="mb-skel-rail-icon" />
                <Shimmer className="mb-skel-rail-label" />
              </div>
            ))}
          </aside>

          <div className="menu-browse-content mb-skel-content" aria-hidden>
            <Shimmer className="mb-skel-banner" />
            <div className="menu-browse-grid mb-skel-grid">
              {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="mb-skel-card">
                  <Shimmer className="mb-skel-card-img" />
                  <div className="mb-skel-card-body">
                    <Shimmer className="mb-skel-card-price" />
                    <Shimmer className="mb-skel-card-name" />
                    <Shimmer className="mb-skel-card-name mb-skel-card-name--short" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuBrowseSkeleton;
